export default "__VITE_ASSET__w56dKBon__"